import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { PageAnimation } from './types';

interface PageTransitionProps {
  animation: PageAnimation;
  /** Changes with every page turn — triggers the transition. */
  pageKey: string | number;
  children: ReactNode;
}

const slideVariants = {
  initial: { x: 40, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: -40, opacity: 0 },
};

const fadeVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export function PageTransition({ animation, pageKey, children }: PageTransitionProps) {
  // No-animation path: render children directly, no motion wrapper.
  if (animation === PageAnimation.None) {
    return <>{children}</>;
  }

  const variants = animation === PageAnimation.Fade ? fadeVariants : slideVariants;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={pageKey}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.22, ease: 'easeOut' }}
        style={{ width: '100%', height: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
